import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header";
import Intro from "./Intro";
import "./home.css";
import EdgeTech from "./CuttingEdge";
import Team from "./Team";
import Journey from "./Journey";
import TeamType from "./TeamTypes";
import CurrentOpenings from "./Openings";
import Credits from "./Credits";
import Feeds from "./Feed";
import Sales from "./Sales";
import Footer from "../Footer";

const Home = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <Header />
      <div className="mt-20 py-5">
        <Intro />
      </div>
      <div className="">
        <EdgeTech />
      </div>
      <div className="">
        <Journey />
      </div>
      <div className="py-0">
        <Team />
      </div>
      <div className="py-0">
        <TeamType />
      </div>
      <div className="">
        <CurrentOpenings />
      </div>
      <div className="">
        <Credits />
      </div>
      <div className="">
        <Feeds />
      </div>
      <div className="">
        <Sales title="Contact sales to discuss our products and solutions." />
      </div>
      <Footer />
    </>
  );
};

export default Home;
